import React from 'react'

export const NameFooter = () => {
  return (
    <div>
      <hr />
      <div style={{ textAlign:"center", fontSize:"15px", marginTop:20}}>Developed by <a style={{color:"black"}} href='https://www.linkedin.com/in/lishakothari/'>Lisha Kothari</a></div> 
    </div>
  )
}